import React from 'react'
import { AdminRightsListItem } from './AdminRightsListItem'
import { IUserModel } from '../../../interfaces/models/users.interfaces'
import { ISocietiesModel } from '../../../interfaces/models/societies.interfaces'

interface AdminRightsListProps {
  admins: {
    user: IUserModel & { fullName: string }
    role: string
  }[]
  society: ISocietiesModel
}

export const AdminRightsList = ({
  admins,
  society,
}: AdminRightsListProps): React.ReactNode => {
  return (
    <div className="h-full w-full space-y-4">
      {admins.map((admin) => (
        <AdminRightsListItem
          key={admin.user._id}
          society={society}
          admin={admin}
        />
      ))}
    </div>
  )
}
